// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "hidden-15zJg";
var _4 = "icon_selected-xcbPP";
var _5 = "flights-jXSbZ";
var _6 = "flight-3F2ac";
var _7 = "flight_readonly-1sNuS";
var _8 = "flight__card-RYE0o";
var _9 = "aircraft-1KKOm";
export { _1 as "__esModule", _2 as "mobile", _3 as "hidden", _4 as "icon_selected", _5 as "flights", _6 as "flight", _7 as "flight_readonly", _8 as "flight__card", _9 as "aircraft" }
export default { "__esModule": _1, "mobile": _2, "hidden": _3, "icon_selected": _4, "flights": _5, "flight": _6, "flight_readonly": _7, "flight__card": _8, "aircraft": _9 }
